import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Offer as OfferType } from 'hooks/webapi/application/useFirstLoanOfferQuery';
import { ClientOffer } from 'hooks/webapi/client/useClientOfferQuery';
import Offer from 'components/Calculator/Offer';
import Placeholder from 'components/Placeholder/Placeholder';
import Slider from '../Slider/Slider';
import styles from './CalculatorBestOffer.module.scss';

export type Constraints = {
  min: number;
  max: number;
  step: number;
};

export type Props = {
  onAmountChange: (value: number) => void;
  constraints: Constraints;
  offer?: OfferType | ClientOffer;
  loading?: boolean;
  calculatorAmount?: number;
  disabledSlider?: boolean;
};

const CalculatorBestOffer = memo(function Calculator({
  onAmountChange,
  constraints,
  offer,
  loading,
  calculatorAmount,
  disabledSlider,
}: Props) {
  const { t } = useTranslation('calculator');
  return (
    <div className={styles['calculator-wrapper']}>
      <div className={styles['desktop-slider-wrapper']}>
        <Slider
          min={constraints.min}
          max={constraints.max}
          step={constraints.step}
          value={
            calculatorAmount !== undefined ? calculatorAmount : constraints.max
          }
          onAfterChange={onAmountChange}
          units={t('amount_units')}
          heading={t('term_slider_title')}
          disabled={disabledSlider}
        />
      </div>

      <hr className={styles['offer-separator']} />
      <div className={styles['offer-wrapper']}>
        <Placeholder loading={!offer}>
          <Offer
            loading={loading || !offer}
            offer={offer}
            dataTest="bestOffer"
          />
        </Placeholder>
      </div>
    </div>
  );
});

export default CalculatorBestOffer;
